import { ActionResult } from "data/StepWithAction";

export const isFieldsNotEmpty = (fields: string[], message: string): ActionResult => {
    let isCompleted = false;
    // eslint-disable-next-line consistent-return
    fields.forEach((field) => {
        const input = document.querySelector(field) as HTMLInputElement | null;
        isCompleted = input !== null && input.value.trim() !== '';
        if (!isCompleted) {
            return { isCompleted, message };
        }
    });
    return { isCompleted };
}